import React from "react";

export default function DraftBlogHeader() {
  return (
    <div className="mb-6">
      <h1 className="font-extrabold text-3xl sm:text-4xl text-slate-900">
        Draft <span className="text-[#7209B7]">Blog</span>
      </h1>
    </div>
  );
}
